import React from 'react';
import ReactDOM from 'react-dom';

import {CustomCircularProgressProps} from "./type";
import {s} from "./style";
import loadingGif from "@shared/assets/gif/loading.gif"
import SizedBox from "@shared/ui/sized-box";

const CustomCircularProgress: React.FC<CustomCircularProgressProps> = (props: CustomCircularProgressProps) => {
    if (!props.isOpen) return null;

    return ReactDOM.createPortal(
        <s.ModalOverlay>
            <s.ModalContent>
                <s.LoadingContainer>
                    <img src={loadingGif} width={200} alt={"loading"}/>
                </s.LoadingContainer>
                <s.TitleText>처리중입니다</s.TitleText>
                <SizedBox height={10}></SizedBox>
                <s.ContentText>잠시만 기다려 주세요</s.ContentText>
                {props.onClose && <s.CloseButton onClick={props.onClose}>닫기</s.CloseButton>}
            </s.ModalContent>
        </s.ModalOverlay>,
        document.body
    );
};

export default CustomCircularProgress;
